import defaultApi from './defaultApi';

const eventApi = {
  event: {
    prefix: process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings/event',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {},
    SAMPLE: {},

    getEventPolicies(policyId, productTypeCode, needHandleAuthorizationCheck = false) {
      return new Promise((resolve, reject) => {
        this.get(
          `/v1/console/event-policies/${policyId}`,
          {},
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          needHandleAuthorizationCheck
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    getEventTemplateDetail(templateId, resourceType, param = {}) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/event-templates/${templateId}/notifications`, param, true, false, {
          headers: { 'X-ResourceType': resourceType }
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    getEventAlert(params, loadingBar = true) {
      return new Promise((resolve, reject) => {
        const defaultParams = {
          eventState: 'ACTIVE',
          size: 7,
          page: 0
        };
        this.post(
          '/v1/console/all-projects/events',
          { ...defaultParams, ...params },
          loadingBar,
          false
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    }
  }
};
eventApi.event = Object.assign(eventApi.event, defaultApi);
export default eventApi;
